import {
  Box,
  Collapse,
  Drawer,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { BodyContentDrawer, SideBar } from "./Layout.styles";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useEffect, useState } from "react";
import {
  Person,
  ExpandLess,
  ExpandMore,
  ShoppingCart,
  Category,
  Flag,
  Factory,
  StoreMallDirectory,
  Logout,
} from "@mui/icons-material";
import { Outlet, useLocation, useNavigate } from "react-router";
import Guard from "../../router/Guard";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { useUserInformation } from "../../context/userInformation/UserInformationContext";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { USER_TYPE } from "../../Constant";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import PaymentIcon from "@mui/icons-material/Payment";

interface IpathExt {
  text: string;
  path: string;
  icon: React.ReactElement;
  selected?: boolean;
  hide?: boolean;
  title: string;
}
interface IPath {
  text: string;
  path: string;
  title: string;
  icon: React.ReactElement;
  expand?: boolean;
  hide?: boolean;
  ext?: IpathExt[];
}

export default function Layout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const userInformation = useUserInformation();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [navigationPath, setNavigationPath] = useState<IPath[]>([]);
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(-1);
  const [title, setTitle] = useState("");
  const [role, setRole] = useState<string | undefined>();
  const isAsSPM = userInformation.validateByRole("SPM");

  useEffect(() => {
    if (userInformation && userInformation.get()?.role) {
      setRole(
        USER_TYPE.find((item) => item.role === userInformation.get()?.role)
          ?.name
      );
    }
  }, [userInformation]);

  useEffect(() => {
    if (navigationPath && selectedMenuIndex === -1) {
      const urlPath = pathname.split("/");
      const temp = navigationPath.findIndex(
        (item) => item.path === `/${urlPath[1]}`
      );
      setSelectedMenuIndex(temp);
    }
  }, [navigationPath]);

  useEffect(() => {
    if (userInformation.get()) {
      setNavigationPath([
        {
          text: "User",
          path: "/user",
          title: "User",
          icon: <Person style={{ color: "#aeaeae" }} />,
        },
        {
          text: "Brand",
          path: "/brand",
          title: "Brand",
          icon: <Flag style={{ color: "#aeaeae" }} />,
        },
        {
          text: "Kategori",
          path: "/kategori",
          title: "Kategori",
          icon: <Category style={{ color: "#aeaeae" }} />,
        },
        {
          text: "Supplier",
          path: "/supplier",
          title: "Supplier",
          icon: <Factory style={{ color: "#aeaeae" }} />,
        },
        {
          text: "Dealer",
          path: "/dealer",
          title: "Dealer",
          icon: <StoreMallDirectory style={{ color: "#aeaeae" }} />,
        },
        {
          text: "Produk",
          path: "/produk",
          title: "Produk",
          icon: <ShoppingCart style={{ color: "#aeaeae" }} />,
        },
        {
          text: "Invoice",
          path: "/invoice",
          title: "Invoice Penjualan",
          hide: isAsSPM,
          icon: <ReceiptIcon style={{ color: "#aeaeae" }} />,
          ext: [
            {
              icon: <PointOfSaleIcon style={{ color: "#aeaeae" }} />,
              path: "/invoice",
              text: "Penjualan",
              selected: false,
              title: "Invoice Penjualan",
            },
            {
              icon: <ShoppingBasketIcon style={{ color: "#aeaeae" }} />,
              path: "/invoice/pembelian",
              text: "Pembelian",
              selected: false,
              title: "Invoice Pembelian",
            },
            {
              icon: <KeyboardReturnIcon style={{ color: "#aeaeae" }} />,
              path: "/invoice/retur",
              text: "Retur",
              selected: false,
              title: "Retur",
            },
            {
              icon: <PaymentIcon style={{ color: "#aeaeae" }} />,
              path: "/invoice/payment-method",
              text: "Metode Pembayaran",
              selected: false,
              title: "Metode Pembayaran",
            },
          ],
        },
      ]);
    }
  }, [userInformation.get()]);

  function handleOnClick(path: string, index: number, ext?: any) {
    if (ext) {
      setNavigationPath((prev) =>
        prev.map((item) => {
          if (item.path === path) {
            item.expand = !item.expand;
          }
          return item;
        })
      );
      return;
    }
    setSelectedMenuIndex(index);
    navigate(path);
    setOpenDrawer(false);
  }

  function handleLogout() {
    localStorage.clear();
    navigate("/login");
    window.location.reload();
  }

  const ListItemMenu = () => {
    return (
      <List component="nav">
        <Box
          color={"white"}
          paddingLeft={2}
          marginBottom={2}
          marginTop={2}
          display={"flex"}
          alignItems={"center"}
          marginRight={1}
        >
          <img src="/logo.png" style={{ width: 50, height: 50 }} />
          <Typography textAlign={"center"} fontWeight={"bold"}>
            CV Sumber Jaya Elektronik
          </Typography>
        </Box>
        {navigationPath.map((item, index) => {
          return item.hide ? null : (
            <div key={index}>
              <ListItemButton
                style={{ color: "#aeaeae" }}
                onClick={() => {
                  handleOnClick(item.path, index, item.ext);
                  setTitle(item.title);
                }}
              >
                <Box
                  display={"flex"}
                  padding={1}
                  alignItems={"center"}
                  gap={2}
                  width={"100%"}
                  bgcolor={
                    index === selectedMenuIndex ? "rgba(77,77,77,0.6)" : ""
                  }
                  borderRadius={5}
                >
                  <Box>{item.icon}</Box>
                  <Typography>{item.text}</Typography>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    {item.ext ? (
                      item.expand ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )
                    ) : null}
                  </div>
                </Box>
              </ListItemButton>
              {item.ext && item.expand && (
                <Collapse in={true} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.ext.map((itemExt, indexExt) => {
                      return itemExt.hide ? null : (
                        <ListItemButton
                          sx={{ pl: 4 }}
                          key={indexExt + index}
                          onClick={() => {
                            handleOnClick(itemExt.path, index);
                            setTitle(itemExt.title);
                          }}
                        >
                          <ListItemIcon>{itemExt.icon}</ListItemIcon>
                          <ListItemText
                            style={{
                              color: "#aeaeae",
                            }}
                            primary={itemExt.text}
                          />
                        </ListItemButton>
                      );
                    })}
                  </List>
                </Collapse>
              )}
            </div>
          );
        })}
        <ListItemButton onClick={handleLogout}>
          <Box
            display={"flex"}
            padding={1}
            alignItems={"center"}
            gap={2}
            width={"100%"}
            borderRadius={5}
          >
            <Box>
              <Logout style={{ color: "#aeaeae" }} />
            </Box>
            <Typography color={"#aeaeae"}>Logout</Typography>
          </Box>
        </ListItemButton>
      </List>
    );
  };

  return (
    <Guard>
      <Grid container sx={{ backgroundColor: "#ededed" }} minHeight={"100vh"}>
        <SideBar item xs={0} md={3} lg={2} xl={2}>
          <ListItemMenu />
        </SideBar>
        <Grid item xs={12} md={9} lg={10} xl={10}>
          <Box
            bgcolor="white"
            padding={1}
            pl={3}
            display="flex"
            justifyContent="space-between"
            alignItems={"center"}
          >
            <BodyContentDrawer>
              <Box
                onClick={() => setOpenDrawer(true)}
                style={{ cursor: "pointer" }}
              >
                <MenuIcon />
              </Box>
            </BodyContentDrawer>
            <Box>
              <Typography variant="h5" fontWeight="bold">
                {title}
              </Typography>
            </Box>
            <Box display={"flex"} gap={1} alignItems={"center"} pr={1}>
              <AccountCircleIcon style={{ fontSize: 40 }} />
              <Box display={"flex"} flexDirection={"column"}>
                <Typography variant="body2" m={0} p={0}>
                  {userInformation.get()?.name}
                </Typography>
                <Typography
                  variant="caption"
                  m={0}
                  p={0}
                  color={"rgba(50, 48, 48, 0.5)"}
                >
                  {role}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Outlet />
        </Grid>
        <Drawer
          anchor={"left"}
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
        >
          <Box width={280} bgcolor={"#111111"} height={"100%"}>
            <ListItemMenu />
          </Box>
        </Drawer>
      </Grid>
    </Guard>
  );
}
